import React from "react";

import { Field, Inputs, Row } from "2g-form";

import { useToLocaleDateFull } from "b2b/i18n";
import useMessages from "./i18n/useMessages";
import useRezervaceVytvoreniObdobi from "./hooks/useRezervaceVytvoreniObdobi";

export function RezervaceVytvoreniObdobi() {
  const { obdobiLabel } = useMessages();
  const formatter = useToLocaleDateFull();

  const { visible } = useRezervaceVytvoreniObdobi();

  return visible ? (
    <Row styled>
      <Field
        label={obdobiLabel()}
        component={Inputs.PeriodDay}
        path="obdobiOd"
        pathTo="obdobiDo"
        formatterDate={formatter}
      />
    </Row>
  ) : undefined;
}

RezervaceVytvoreniObdobi.propTypes = {};

export default React.memo(RezervaceVytvoreniObdobi);
